import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, ArrowLeftIcon } from 'lucide-react';
const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setSubmitted(true);
      setLoading(false);
    }, 1000);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-1283">
      <div className="max-w-md w-full space-y-8" data-id="element-1284">
        <div data-id="element-1285">
          <div className="mx-auto h-20 w-auto flex items-center justify-center" data-id="element-1286">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qrpHAAKgkN1H9JhJ8LpouX/ThePoint_LogoMark_RGB_Final.png" alt="The Point TMS" className="h-20 w-auto" data-id="element-1287" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-1288">
            Reset your password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1289">
            Enter your email address and we'll send you a link to reset your
            password.
          </p>
        </div>
        {!submitted ? <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1290">
            <div data-id="element-1291">
              <label htmlFor="email-address" className="sr-only" data-id="element-1292">
                Email address
              </label>
              <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm" placeholder="Email address" data-id="element-1293" />
            </div>
            <div data-id="element-1294">
              <button type="submit" disabled={loading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-primary-300" data-id="element-1295">
                {loading ? <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1296">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1297"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1298"></path>
                  </svg> : 'Send reset link'}
              </button>
            </div>
            <div className="flex items-center justify-center" data-id="element-1299">
              <Link to="/login" className="font-medium text-primary-700 hover:text-primary-800 flex items-center" data-id="element-1300">
                <ArrowLeftIcon size={16} className="mr-1" data-id="element-1301" />
                Back to sign in
              </Link>
            </div>
          </form> : <div className="mt-8" data-id="element-1302">
            <div className="rounded-md bg-green-50 p-4" data-id="element-1303">
              <div className="flex" data-id="element-1304">
                <div className="flex-shrink-0" data-id="element-1305">
                  <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1306">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1307" />
                  </svg>
                </div>
                <div className="ml-3" data-id="element-1308">
                  <h3 className="text-sm font-medium text-green-800" data-id="element-1309">
                    Email sent
                  </h3>
                  <div className="mt-2 text-sm text-green-700" data-id="element-1310">
                    <p data-id="element-1311">
                      We've sent a password reset link to {email}. Please check
                      your inbox and follow the instructions to reset your
                      password.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 flex items-center justify-center" data-id="element-1312">
              <Link to="/login" className="font-medium text-primary-700 hover:text-primary-800 flex items-center" data-id="element-1313">
                <ArrowLeftIcon size={16} className="mr-1" data-id="element-1314" />
                Back to sign in
              </Link>
            </div>
          </div>}
      </div>
    </div>;
};
export default ResetPassword;